import { FC } from 'react';
import { exclusionsPageCheckpoint } from 'api/exclusions/exclusionsPageCheckpoint';
import { BackArrowButton } from 'components/_global/back-button/BackArrowButton';
import { Button } from 'components/core/button';
import { Text } from 'components/core/text';
import { H2 } from 'components/core/text/Text';
import { FooterChildrenWrapper } from 'components/structure/footer/FooterChildrenWrapper';
import { FooterPortal } from 'components/structure/footer/FooterPortal';
import { useCurrentUser } from 'contexts/CurrentUserContext';
import { useQueryParams } from 'hooks/useQueryParams';
import PhoneIcon from 'public/assets/img/phone-icon.svg';
import TextIcon from 'public/assets/img/text-message-icon.svg';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import { MemberProgram } from '../constants';

interface ExclusionConfirmComponentProps {
  redirectUrl?: string;
  program?: MemberProgram;
}

const ExclusionConfirmComponent: FC<ExclusionConfirmComponentProps> = ({
  redirectUrl,
  program = MemberProgram.CORE,
}) => {
  const push = useNavigate();
  const user = useCurrentUser();
  const t = useTranslations('RelationshipPage');

  const { getParam } = useQueryParams();
  const memberId = getParam('memberId') || getParam('patientId');

  const handleContinue = () => {
    if (memberId && redirectUrl) {
      push(redirectUrl);
      return;
    }
    if (memberId) push(`/account/exclusion/${memberId}`);
    else push('/account/exclusion');
  };

  return (
    <>
      <div className="py-4 cursor-pointer">
        <BackArrowButton />
      </div>
      {user.state.account ? (
        <div className="flex w-full flex-col">
          <H2>{t('exclusionConfirmTitle1')}</H2>

          <Text variant="text3" color="darkBendBlue">
            {t('exclusionConfirmTitle2')}
          </Text>
          <div className="mt-4">
            <Text>{t('exclusionConfirmText1')}</Text>
          </div>

          <div className="flex w-full flex-col mt-4">
            <div className="flex flex-row mb-4">
              <Text color="greenDark" bold>
                <span className="rounded-full shrink-0">
                  <img className="inline" src={PhoneIcon} />
                </span>{' '}
                <span className="mt-2 ml-2">{t('exclusionConfirmListText1')}</span>
              </Text>
            </div>
            <div className="flex flex-row mb-4">
              <Text color="greenDark" bold>
                <span className="rounded-full shrink-0">
                  <img className="inline" src={TextIcon} />
                </span>{' '}
                <span className="mt-2 ml-2">{t('exclusionConfirmListText2')}</span>
              </Text>
            </div>
          </div>

          <div>
            <Text bold>{t('exclusionConfirmText2')} </Text> <Text>{t('exclusionConfirmText3')} </Text>
          </div>

          <div className="mt-8">
            <Text bold>Would you like to start over?</Text>
          </div>
        </div>
      ) : (
        <></>
      )}
      <FooterPortal>
        <FooterChildrenWrapper>
          <Button variant="secondary" onClick={() => handleContinue()} data-testid="yes">
            <span className="font-semibold">{t('yes')}</span>
          </Button>
          <Button
            onClick={async (e) => {
              e.preventDefault();

              if (memberId) {
                await exclusionsPageCheckpoint(memberId, true, program);
              }
              window.location.href = 'https://www.bendhealth.com/one-percent-better/ask-an-expert';
            }}
            data-testid="no"
          >
            <span className="font-semibold">{t('no')}</span>
          </Button>
        </FooterChildrenWrapper>
      </FooterPortal>
    </>
  );
};

export default ExclusionConfirmComponent;
